
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { DataGrid, GridColumnMenu, GridToolbar } from "@mui/x-data-grid";
import Loader from "../../components/common/Loader";
import Badge from "@mui/material/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faMagnifyingGlass,
  faUserGraduate,
  faEnvelope,
  faUserCheck,
  faIdBadge,
  faFileSignature,
} from "@fortawesome/free-solid-svg-icons";
import { Row, Col } from "react-bootstrap";
import SecCard from "../../components/common/SecCard";
import { green, yellow, red, deepPurple } from "@mui/material/colors";
import { SERVER_ORIGIN } from "../../utilities/constants";
import {
  hasReadOnlyAccess,
  getDashboardPath,
} from "../../utilities/helper_functions";
import HeaderCard from "../../components/common/HeaderCard";
import BackButton from "../../components/common/BackButton";
import Dropdown from "../../components/common/EmDropdown";
import css from "../../css/admin/users-page.module.css";

const AllChapterEM = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [limit, setLimit] = useState(0);
  const [allInstitutes, setAllInstitutes] = useState([]);
  const [page, setPage] = useState(1);
  const [sortType, setSortType] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [mouStatus, setMouStatus] = useState("");
  const [totalPages, setTotalPages] = useState(0);

  const [all_institutes, setAll_institutes] = useState(0);
  const [all_mou_accepted, setAll_mou_accepted] = useState(0);
  const [all_mou_rejected, setAll_mou_rejected] = useState(0);
  const [all_mou_pending, setAll_mou_pending] = useState(0);
  const [
    all_institutes_onboarding_pending,
    setAll_institutes_onboarding_pending,
  ] = useState(0);
  const [
    all_institutes_onboarding_invited,
    setAll_institutes_onboarding_invited,
  ] = useState(0);
  const [all_institutes_email_sent, setAll_institutes_email_sent] = useState(0);
  const [
    all_institutes_onboarding_onboarded,
    setAll_institutes_onboarding_onboarded,
  ] = useState(0);
  const [all_institutes_email_not_sent, setAll_institutes_email_not_sent] =
    useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  // Filter states
  const [filters, setFilters] = useState({
    region: "",
    state: "",
    city: "",
    onboardingStatus: "",
    emailStatus: "",
  });

  const navigate = useNavigate();
  const isReadOnly = hasReadOnlyAccess();
  const currentUserType = sessionStorage.getItem("userType");
  const userRegion = sessionStorage.getItem("region");
  // Get unique values for dropdowns from the data
  const uniqueRegions = [
    ...new Set(allInstitutes.map((item) => item.region).filter(Boolean)),
  ];
  const uniqueStates = [
    ...new Set(allInstitutes.map((item) => item.state).filter(Boolean)),
  ];
  const uniqueCities = [
    ...new Set(allInstitutes.map((item) => item.city).filter(Boolean)),
  ];

  // Debounce search input
  useEffect(() => {
    const handle = setTimeout(
      () => setDebouncedSearch(searchQuery.trim()),
      350
    );
    return () => clearTimeout(handle);
  }, [searchQuery]);

  useEffect(() => {
    async function canVisitPage() {
      setIsLoading(true);
      try {
        const currentUserType = sessionStorage.getItem("userType");
        let verifyEndpoint = "";
        let headers = {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token"),
        };

        if (currentUserType === "admin") {
          verifyEndpoint = `${SERVER_ORIGIN}/api/admin/auth/verify-token`;
          const adminId = process.env.REACT_APP_ADMIN_ID;
          const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;
          const basicAuth = btoa(`${adminId}:${adminPassword}`);
          headers.Authorization = `Basic ${basicAuth}`;
        } else if (currentUserType === "regionem") {
          verifyEndpoint = `${SERVER_ORIGIN}/api/regionem/auth/verify-token`;
        } else {
          navigate("/login");
          return;
        }

        const response = await fetch(verifyEndpoint, {
          method: "POST",
          headers: headers,
        });

        const result = await response.json();

        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            navigate(`/login?userType=${currentUserType}`);
          } else {
            toast.error(result.statusText);
          }
        }
      } catch (err) {
        console.log(err.message);
        navigate("/login");
      }
      setIsLoading(false);
    }

    async function getAllEms() {
      setIsLoading(true);
      try {
        let regionQuery = "";
        if (currentUserType === "regionem" && userRegion) {
          regionQuery = `&region=${userRegion}`;
        }
        const response = await fetch(
          `${SERVER_ORIGIN}/api/em/auth/em/all?page=${page}&limit=${limit}&search=${debouncedSearch}&sortBy=name&sortType=${sortType === true ? "asc" : "desc"
          }${regionQuery}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem("token"),
            },
          }
        );

        const result = await response.json();
        setIsLoading(false);
        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            navigate("/admin/services");
          } else if (response.status === 500) {
            toast.error(result.statusText);
          }
        } else if (response.status === 200) {
          setAllInstitutes(result.filteredInstitutes);
          setTotalPages(result.totalPages);
          setMouStatus(result.filteredInstitutes.mouStatus);
        }
      } catch (err) {
        setIsLoading(false);
      }
    }

    async function countingEM() {
      setIsLoading(true);
      try {
        const response = await fetch(`${SERVER_ORIGIN}/api/em/auth/counting`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": sessionStorage.getItem("token"),
          },
        });

        const result = await response.json();
        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            navigate("/login?userType=institute");
          }
        } else if (response.ok && response.status === 200) {
          setAll_institutes(result.data.all_institutes);
          setAll_mou_accepted(result.data.all_mou_accepted);
          setAll_mou_rejected(result.data.all_mou_rejected);
          setAll_mou_pending(result.data.all_mou_pending);
          setAll_institutes_onboarding_pending(
            result.data.all_institutes_onboarding_pending
          );
          setAll_institutes_onboarding_invited(
            result.data.all_institutes_onboarding_invited
          );
          setAll_institutes_email_sent(result.data.all_institutes_email_sent);
          setAll_institutes_onboarding_onboarded(
            result.data.all_institutes_onboarding_onboarded
          );
          setAll_institutes_email_not_sent(
            result.data.all_institutes_email_not_sent
          );
        } else {
          navigate("/admin/login");
        }
      } catch (err) {
        console.log(err.message);
      }
      setIsLoading(false);
    }

    canVisitPage();
    getAllEms();
    countingEM();
  }, [page, sortType, debouncedSearch, navigate]);

  // Handle filter changes
  const handleFilterChange = (filterName, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  // Apply filters to data
  const filteredInstitutes = allInstitutes.filter((institute) => {
    return (
      (!filters.region || institute.region === filters.region) &&
      (!filters.state || institute.state === filters.state) &&
      (!filters.city || institute.city === filters.city) &&
      (!filters.onboardingStatus ||
        institute.onboardingSatus === filters.onboardingStatus) &&
      (!filters.emailStatus ||
        institute.emailSentStatus === filters.emailStatus)
    );
  });

  // Clear all filters
  const clearAllFilters = () => {
    setFilters({
      region: "",
      state: "",
      city: "",
      onboardingStatus: "",
      emailStatus: "",
    });
    setSearchQuery("");
  };

  const handleButtonClick = (id) => {
    setSelectedId(id);
    setIsOpen(!isOpen);
  };

  const renderOnboardingStatus = (params) => {
    let statusColor;
    let statusText;
    let textColor;

    switch (params.value) {
      case "invited":
        statusColor = yellow[500];
        statusText = "Invited";
        textColor = "black";
        break;
      case "pending":
        statusColor = deepPurple[500];
        statusText = "Pending";
        textColor = "white";
        break;
      case "onboarded":
        statusColor = green[500];
        statusText = "Onboarded";
        textColor = "white";
        break;
      case "approved":
        statusColor = green[500];
        statusText = "Approved";
        textColor = "white";
        break;
      case "rejected":
        statusColor = red[500];
        statusText = "Rejected";
        textColor = "white";
        break;
      case "submitted":
        statusColor = yellow[500];
        statusText = "Submitted";
        textColor = "black";
        break;
      default:
        statusColor = "black";
        statusText = "Unknown";
        textColor = "white";
    }
    return (
      <Badge>
        <span
          style={{
            backgroundColor: statusColor,
            padding: "6.4px 16px",
            borderRadius: "8px",
            color: textColor,
          }}
        >
          {statusText}
        </span>
      </Badge>
    );
  };

  const renderEmailStatus = (params) => {
    let statusColor;
    let statusText;
    let textColor;

    switch (params.value) {
      case "sent":
        statusColor = green[500];
        statusText = "Sent";
        textColor = "white";
        break;
      case "not sent":
        statusColor = red[500];
        statusText = "Not Sent";
        textColor = "white";
        break;
      default:
        statusColor = "black";
        statusText = "Unknown";
        textColor = "white";
    }
    return (
      <Badge>
        <span
          style={{
            borderRadius: "8px",
            backgroundColor: statusColor,
            padding: "6.4px 16px",
            color: textColor,
          }}
        >
          {statusText}
        </span>
      </Badge>
    );
  };

  // Elevate on hover component for cards
  const ElevateOnHover = ({ children }) => {
    const [hovered, setHovered] = useState(false);
    return (
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          borderRadius: 12,
          background: "#ffffff",
          transition: "box-shadow 200ms ease, transform 200ms ease",
          boxShadow: hovered
            ? "0 8px 24px rgba(16,24,40,.12)"
            : "0 1px 3px rgba(16,24,40,.06)",
          transform: hovered ? "translateY(-2px)" : "none",
        }}
      >
        {children}
      </div>
    );
  };

  // Stat Card Component
  const StatCard = ({ title, value, icon, gradient }) => (
    <ElevateOnHover>
      <div className={css.dashboardCard} style={{ overflow: "hidden" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 16px",
          }}
        >
          <h3
            className={css.cardTitle}
            style={{ margin: 0, fontSize: "14px", color: "#6b7280" }}
          >
            {title}
          </h3>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: gradient,
              color: "#fff",
            }}
          >
            <FontAwesomeIcon icon={icon} />
          </div>
        </div>
        <div
          className={css.cardContent}
          style={{ paddingTop: 0, padding: "0 16px 16px" }}
        >
          <div
            style={{ fontSize: "24px", fontWeight: "600", color: "#1f2937" }}
          >
            {value}
          </div>
        </div>
      </div>
    </ElevateOnHover>
  );

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 80,
    },
    {
      field: "name",
      headerName: "Name",
      width: 170,
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
    },
    {
      field: "number",
      headerName: "Mobile Number",
      width: 150,
    },
    {
      field: "chapterName",
      headerName: "Chapter Name",
      width: 150,
    },
    {
      field: "regionalManagerName",
      headerName: "CII Regional Director",
      width: 180,
    },
    {
      field: "instituteCount",
      headerName: "Invited Institutes",
      align: "center",
      width: 150,
    },
    {
      field: "region",
      headerName: "Region",
      width: 150,
    },
    {
      field: "state",
      headerName: "State",
      width: 150,
    },
    {
      field: "city",
      headerName: "City",
      width: 150,
    },
    {
      field: "designation",
      headerName: "Designation",
      width: 150,
    },
    // {
    //   field: "emailSentStatus",
    //   headerName: "Email Sent Status",
    //   align: "center",
    //   width: 160,
    //   renderCell: renderEmailStatus,
    // },
    {
      field: "onboardingSatus",
      headerName: "Onboarding Status",
      width: 160,
      align: "center",
      renderCell: renderOnboardingStatus,
    },
    {
      field: "updatedAt",
      headerName: "Last Updated",
      align: "center",
      width: 140,
      valueGetter: (params) => params.row.updatedAt || params.row.createdAt || null,
      valueFormatter: (params) => {
        if (!params.value) return "-";
        const d = new Date(params.value);
        return d.toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
      renderCell: (params) => (
        <span style={{ whiteSpace: "normal", lineHeight: 1.3 }}>
          {params.formattedValue || params.value || "-"}
        </span>
      ),
    },
    {
      headerName: "Action",
      width: 130,
      renderCell: (params) => {
        const {
          row: { _id },
        } = params;

        if (isReadOnly) {
          return (
            <div className="d-flex justify-content-center">
              <span className="badge bg-secondary">View Only</span>
            </div>
          );
        }

        return (
          <div className="d-flex justify-content-between">
            <Dropdown _id={_id} />
          </div>
        );
      },
    },
  ];

  function handleInstitutesClick() {
    navigate("/ems/insert");
  }

  function CustomColumnMenu(props) {
    return (
      <GridColumnMenu
        {...props}
        slotProps={{
          columnMenuUserItem: {
            displayOrder: 15,
            myCustomValue: "Do custom action",
            myCustomHandler: () => alert("Custom handler fired"),
          },
        }}
      />
    );
  }

  const rows = filteredInstitutes.map((institute, idx) => ({
    ...institute,
    id: idx + 1,
  }));

  return (
    <div className={css.outerDiv}>
      <div className={css.headerSection}>
        <div className={css.headerLeft}>
          <BackButton
            text="Back to Dashboard"
            customPath={getDashboardPath()}
          />
        </div>
      </div>

      {isReadOnly && (
        <div className={css.readOnlyAlert}>
          <div className="alert alert-info" role="alert">
            <strong>Read-Only Access:</strong> You can view all Chapter EM data
            but cannot add, edit, or delete any records.
          </div>
        </div>
      )}

      {/* Dashboard Stats Section */}
      <div className="my-4">
        <SecCard>
          <Row className="g-4">
            <div
              className={`${css.serviceHeader} d-flex justify-content-between align-items-center mb-3`}
            >
              <div className={css.serviceName}>Chapter EM Data</div>

              <div className={css.headerRight}>
                {!isReadOnly && (
                  <button
                    className={css.addBtn}
                    onClick={handleInstitutesClick}
                  >
                    <FontAwesomeIcon icon={faPlus} className={css.addIcon} />
                    Add Chapter EM
                  </button>
                )}
              </div>
            </div>

          </Row>
        </SecCard>
      </div>

      {/* Search and Filters Section */}
      <div className={css.searchFiltersSection}>
        <div className={css.filtersContainer}>
          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Search</label>
            <div className={css.searchInputWrapper}>
              <input
                type="text"
                value={searchQuery}
                placeholder="Search here..."
                onChange={(e) => setSearchQuery(e.target.value)}
                className={css.searchInput}
              />
              {/* <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className={css.searchIcon}
              /> */}
            </div>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Region</label>
            <select
              value={filters.region}
              onChange={(e) => handleFilterChange("region", e.target.value)}
              className={css.filterSelect}
            >
              <option value="">All Regions</option>
              {uniqueRegions.map((region) => (
                <option key={region} value={region}>
                  {region}
                </option>
              ))}
            </select>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>State</label>
            <select
              value={filters.state}
              onChange={(e) => handleFilterChange("state", e.target.value)}
              className={css.filterSelect}
            >
              <option value="">All States</option>
              {uniqueStates.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>City</label>
            <select
              value={filters.city}
              onChange={(e) => handleFilterChange("city", e.target.value)}
              className={css.filterSelect}
            >
              <option value="">All Cities</option>
              {uniqueCities.map((city) => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </select>
          </div>


          <button onClick={clearAllFilters} className={css.clearFiltersBtn}>
            Clear All
          </button>
        </div>
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <div className={css.dataGridContainer}>
          <DataGrid
            rows={rows}
            columns={columns}
            autoHeight
            density="compact"
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            disableRowSelectionOnClick
            sx={{
              borderRadius: 2,
              border: "1px solid #e5e7eb",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f9fafb",
                color: "#111827",
                fontWeight: 600,
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                backgroundColor: "#fcfcfd",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#eef2ff",
              },
            }}
            slots={{ columnMenu: CustomColumnMenu, toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 300 },
              },
            }}
            loading={isLoading}
          />
        </div>
      )}
    </div>
  );
};

export default AllChapterEM;